// assets
import TeamOutlined from '@ant-design/icons/TeamOutlined';

const icons = { TeamOutlined };

// ==============================|| MENU ITEMS - BROKERS ||============================== //

const brokers = {
  id: 'brokers',
  title: 'Brokers',
  type: 'group',
  url: '/brokers',
  icon: icons.TeamOutlined,
  permission: {
    module: 'brokers',
    level: 10 // View permission required
  }
};

export default brokers;
